module.exports = __webpack_public_path__ + "img/05.41d234f8.png";